export default __webpack_public_path__ + "static/media/more-option.4082570a.svg";